import { useNavigate } from 'react-router-dom'

function LandingFooter () {
  const navigate = useNavigate()

  return (
    <footer className='lp-landing-footer'>
      <div className='lp-footer-content'>
        <div className='lp-footer-brand'>
          <h3>Engineers Knowledge Base</h3>
          <p>Die intelligente Wissensdatenbank für Servicetechniker</p>
        </div>
        <div className='lp-footer-links'>
          <div className='lp-footer-column'>
            <h4>Produkt</h4>
            <a href='#features'>Features</a>
            <a href='#contact'>Demo anfragen</a>
          </div>
          <div className='lp-footer-column'>
            <h4>Support</h4>
            <a href='#contact'>Kontakt</a>
            <a onClick={() => navigate('/login')}>Anmelden</a>
            <a onClick={() => navigate('/register')}>Registrieren</a>
          </div>
        </div>
      </div>
      <div className='lp-footer-bottom'>
        <p>© 2025 Engineers Knowledge Base. Alle Rechte vorbehalten.</p>
      </div>
    </footer>
  )
}

export default LandingFooter

